<template>
  <div v-if="tab === 'Top Stats' && isProvider" class="dashboard-graph-cards">
    <div class="row custom-card-group">
      <ProviderDashboard />
    </div>
    <hr class="mx-2 pb-0" />
  </div>
  <div v-if="tab === 'Top Stats' && !isProvider" class="dashboard-graph-cards">
    <div class="row custom-card-group">
      <div v-if="!services">
        <Loader topServices="true" />
      </div>
      <div v-for="(item, idx) of services" :key="idx" class="col card custom-card">
        <div class="card-body custom-card-body">
          <p class="card-text">{{ item.name }}</p>
          <h5 class="card-title custom-card-title">{{ item.number }}</h5>
        </div>
      </div>
    </div>
    <div v-if="services?.length === 0">
      <Loader topServicesEmpty="true" />
    </div>
    <div class="row m-0">
      <div class="col my-2 px-2 text-center">
        <div>
          <span class="custom-inspection-label">Total # of ADAS VIN Inspections:</span>
          <span class="custom-inspection">{{ totalInspections }}</span>
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-md col-12 my-2 px-2">
        <AppCard v-if="cardData?.TopShops" cardTitle="Top Shops" routing="true" cardIconClass="fa fa-cog" :cardData="cardData.TopShops"></AppCard>
        <div v-if="!cardData">
          <Loader topcards="true" />
        </div>
      </div>
      <!-- <div class="col-md col-12 my-2 px-2">
        <AppCard
          v-if="cardData?.TopInsurance"
          cardTitle="Top Insurance "
          routing="false"
          cardIconClass="fa fa-cog"
          :cardData="cardData.TopInsurance"
        ></AppCard>
        <div v-if="!cardData">
          <Loader topcards="true" />
        </div>
      </div> -->
      <div class="col-md col-12 my-2 px-2">
        <AppCard v-if="cardData?.TopMakes" routing="false" cardTitle="Top Makes" cardIconClass="fa fa-cog" :cardData="cardData.TopMakes"></AppCard>
        <div v-if="!cardData">
          <Loader topcards="true" />
        </div>
      </div>
      <div class="col-md col-12 my-2 px-2">
        <AppCard
          v-if="cardData?.TopEstimators"
          routing="false"
          cardTitle="Top Estimators"
          cardIconClass="fa fa-cog"
          :cardData="cardData.TopEstimators"
        ></AppCard>
        <div v-if="!cardData">
          <Loader topcards="true" />
        </div>
      </div>
    </div>
    <hr class="mx-2 pb-0" />
  </div>
  <div v-if="tab === 'Locations'">
    <MemberListing ref="membership" :firm="selectedFirm" :show-title="false" :isDashboard="true" />
  </div>
  <div v-if="tab === 'LocationsOLD'">
    <ZHeader :headerProps="headerProps" :listParams="listParams" :isPaginated="false" :showTitle="false" @toggle="toggleAction" @search="search" />
    <div v-if="showTable" class="shop-list">
      <div v-if="shopCardData" class="dashboard-data-table pb-4 pt-3">
        <ZTable
          v-model="shopListDetailsTable.tableData"
          class="table table-bordered table-striped mt-4"
          :is-single-row-detail="false"
          :is-header-fixed="true"
          :columns="shopListDetailsTable.tableHeader"
          @sort="sortColumn"
        >
          <template #tbody="props">
            <td class="custom-column-60-center">
              <button class="btn btn-link" @click="viewRecord(props.row)">view</button>
            </td>
            <td>
              <div>
                <p class="colorPrimary fw-6 fs-16 m-0">{{ props.row.name }}</p>
                <div class="row">
                  <div class="col">
                    <p class="colorPrimary fs-12 m-0">{{ props.row.address }}</p>
                  </div>
                  <div class="col-2">
                    <p class="colorPrimary fs-12 m-0">{{ props.row.estimatingId }}</p>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">{{ props.row.inspections }}</td>
            <td class="text-center">{{ props.row.servicesRequired }}</td>
          </template>
          <template #empty> Nothing found! </template>
        </ZTable>
      </div>
      <div v-else style="height: 250px" class="loader"></div>
    </div>
    <div v-if="!showTable" class="shop-card">
      <div v-if="!shopCardData">
        <Loader card="true" />
      </div>
      <div v-if="shopCardData" class="row m-0 dashboard-shop-card">
        <div v-if="shopCardData === 'noData'">
          <Loader emptyCard="true" />
        </div>
        <div class="row" v-else>
          <div v-for="item in shopCardData" :key="item.firm" class="col-12 col-sm-6 col-md-3 shop-list-container p-2" @click="viewRecord(item)">
            <div class="shop-list-div p-3">
              <div class="shop-header-mobile pb-3">
                <p class="shop-name-mobile colorPrimary text-start fw-6 fs-16 m-0">
                  {{ item.name }}
                </p>
                <div class="row">
                  <div class="col">
                    <p class="colorPrimary text-start m-0 fs-12">{{ item.address }}</p>
                  </div>
                  <div class="col-2">
                    <p class="colorPrimary text-start m-0 fs-12">{{ item.estimatingId }}</p>
                  </div>
                </div>
              </div>
              <div class="shop-body-mobile d-flex justify-content-between pt-3">
                <div>
                  <p class="text-start colorPrimary fs-12 m-0">ADAS Inspections</p>
                  <p class="shop-service-required-mobile fs-14 colorPrimary text-start fw-b m-0">
                    {{ item.inspections ? item.inspections : 0 }}
                  </p>
                </div>
                <div>
                  <p class="text-start fs-12 colorPrimary m-0">Service Ops</p>
                  <p class="shop-service-completed-mobile text-start fs-14 colorPrimary fw-b m-0">
                    {{ item.servicesRequired ? item.servicesRequired : 0 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import ZHeader from '@/components/utilities/elements/TableHeader.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
import AppCard from '@/components/dashboard/elements/AppCard.vue'
import SplineChart from '@/components/dashboard/charts/SplineChart.vue'
import Loader from '@/components/utilities/elements/Loader.vue'
import ProviderDashboard from '@/components/dashboard/elements/ProviderDashboard.vue'
import MemberListing from '@/components/members/MemberListing.vue'
export default {
  name: 'RepairNetwork',
  components: {
    ZHeader,
    ZTable,
    AppCard,
    SplineChart,
    Loader,
    ProviderDashboard,
    MemberListing
  },
  props: {
    tab: String
  },
  data() {
    return {
      showTable: false,
      headerProps: {
        pages: 0,
        pageSizes: [],
        numItems: 0,
        title: null,
        subtitle: null,
        isTitle: false,
        isPaginated: false,
        isChecked: false,
        isAdd: false,
        isDelete: false,
        toggleButtons: [
          {
            name: 'Show Cards',
            value: 2,
            checked: true
          },
          {
            name: 'Show List',
            value: 1,
            checked: false
          }
        ],
        buttons: null
      },
      listParams: {
        page: 0,
        pageSize: 10,
        filterBy: null,
        searchTerm: null
      }
    }
  },
  emits: ['view'],
  watch: {
    tab() {
      if (this.tab === 'Locations') {
        setTimeout(() => {
          console.log('Locations Tab - refreshing membership', this.selectedFirm)

          if (this.$refs.membership) {
            this.$refs.membership.search(1, '')
          }
        }, 250)
      }
    },
    selectedInsurer() {
      if (this.tab === 'Locations') {
        setTimeout(() => {
          console.log('Locations Tab - refreshing membership', this.selectedFirm)

          if (this.$refs.membership) {
            this.$refs.membership.search(1, '')
          }
        }, 250)
      }
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(dashboardStore, ['tableDetails', 'shopCardData', 'cardData', 'chartData', 'totalInspections', 'selectedInsurer']),
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    shopListDetailsTable() {
      return this.tableDetails
    },
    lineChartData() {
      return this.chartData
    },
    services() {
      let _data = []
      if (this.cardData) {
        _data = this.cardData.TopServices
      }
      return _data
    },
    selectedFirm() {
      let _firm = null
      if (this.profile) {
        _firm = {
          firm: this.profile.firm,
          type: this.profile.firmType
        }
      }
      return _firm
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['searchExisting', 'setFirm']),
    toggleAction(value) {
      this.showTable = false
      this.headerProps.toggleButtons.forEach((x) => {
        x.checked = false
        if (x.value === value) {
          x.checked = true
          if (x.name === 'Show List') {
            this.showTable = true
          }
        }
      })
    },
    search(term) {
      console.log('Searching', term)
      this.searchExisting(term, 'shopCardData')
      if (term === '') {
        console.log('Resetting Search')
        this.listParams.searchTerm = null
      }
    },
    viewRecord(firm) {
      console.log('View Location (RN List)', firm)
      this.setFirm(firm)
      this.$emit('view', firm)
      router.push(`/repairNetwork/${firm.firm}`)
    },
    sortColumn(data, sortBy) {
      this.sortArray(this.shopListDetailsTable.tableData, data.field, sortBy)
    },
    async sortArray(data, sortOn, dir) {
      let _data = Array.from(new Set(data)).sort(function (a, b) {
        if (a[0] === b[0]) {
          var x = a[sortOn]
          var y = b[sortOn]
          if (dir) {
            if (dir.toUpperCase() === 'ASC') {
              return x < y ? -1 : x > y ? 1 : 0
            }
            if (dir.toUpperCase() === 'DESC') {
              return x > y ? -1 : x < y ? 1 : 0
            }
          } else {
            return x < y ? -1 : x > y ? 1 : 0
          }
        }
        return a[0] - b[0]
      })
      this.shopListDetailsTable.tableData = _data
    }
  }
}
</script>
<style lang="scss" scoped>
hr {
  color: #b3b4b9;
}
.line-chart-cards {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 6px 12px 0 rgba(57, 99, 93, 0.05);
  background: var(--default-light);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
}
.dashboard-shop-card {
  max-height: 560px;
  overflow: auto;
}
.shop-header-mobile {
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.shop-list-container:nth-child(even) {
  background-color: #fcfcfd;
}
.shop-list-div:hover {
  background-color: rgb(97 169 36 / 10%);
  cursor: pointer;
}
.shop-list-div {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 10px;
}
.custom-inspection-label {
  font-size: 1.1em;
  font-weight: 600;
}
.custom-inspection {
  margin-left: 10px;
  font-size: 1.4em;
  font-weight: 600;
}
</style>
